import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tabs,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabs) = $event)),
        "align-tabs": "center",
        color: "purple darken-3",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: 1 }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Anúncios")
            ])),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            onClick: _ctx.getaution,
            value: 2
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Leilões")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: _ctx.tabs,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabs) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAnaucement, (announcement) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: announcement.id,
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          to: { name: _ctx.anaucedetalpage, params: { id: announcement.uuid } },
                          class: "mx-auto",
                          "max-width": "400",
                          elevation: "3",
                          color: "white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "headline white--text text-shadow" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(announcement.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_img, {
                              src: announcement.photoUrl,
                              height: "200px",
                              class: "elevation-1"
                            }, null, 8, ["src"]),
                            _createVNode(_component_v_card_subtitle, { class: "grey--text text-darken-2" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(announcement.city) + ", " + _toDisplayString(announcement.province), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_card_text, { class: "text-h5 font-weight-bold text--primary" }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Mtn " + _toDisplayString(announcement.price), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "purple darken-2",
                                  dark: ""
                                }, {
                                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                                    _createTextVNode("Ver detalhes")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    color: "purple darken-2",
                    class: "d-flex justify-center mt-5"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autonsList, (aution) => {
                    return (_openBlock(), _createBlock(_component_v_col, {
                      key: aution.id,
                      cols: "12",
                      sm: "6",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          to: {name:_ctx.autiondetailpage, params:{id:aution.uuid}},
                          class: "mx-auto",
                          "max-width": "400",
                          elevation: "3",
                          color: "white"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "headline white--text text-shadow" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(aution.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_img, {
                              src: aution.photoUrl,
                              height: "200px",
                              class: "elevation-1"
                            }, null, 8, ["src"]),
                            _createVNode(_component_v_card_text, { class: "text-darken-3" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Data de término:", -1)),
                                  _createTextVNode(" " + _toDisplayString(aution.endsAt), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Preço inicial:", -1)),
                                  _createTextVNode(" Mtn " + _toDisplayString(aution.inicialPrice), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Localização:", -1)),
                                  _createTextVNode(" " + _toDisplayString(aution.city) + ", " + _toDisplayString(aution.province), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  color: "purple darken-2",
                                  dark: ""
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode("Participar do leilão")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                    key: 0,
                    indeterminate: "",
                    color: "purple darken-2",
                    class: "d-flex justify-center mt-5"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}